"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var _core = require("@material-ui/core");

var _useStyles = _interopRequireDefault(require("./useStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Panel = function Panel(_ref) {
  var swap = _ref.swap,
      title = _ref.title,
      body = _ref.body,
      image = _ref.image,
      children = _ref.children;
  var classes = (0, _useStyles["default"])({
    swap: swap
  });
  return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_gatsbyImage["default"], _extends({}, image, {
    fadeIn: true,
    objectFit: "cover",
    className: classes.imageWrapper
  }))), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6,
    className: [classes.textWrapper, classes.swap].join(' ')
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    p: 5
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "h4",
    component: "h3"
  }, title), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1",
    className: classes.body
  }, body), children)));
};

Panel.defaultProps = {
  swap: false,
  children: null
};
Panel.propTypes = {
  title: _propTypes["default"].string.isRequired,
  body: _propTypes["default"].string.isRequired,
  swap: _propTypes["default"].bool,
  // eslint-disable-next-line react/forbid-prop-types
  image: _propTypes["default"].object.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object, _propTypes["default"].func])
};
var _default = Panel;
exports["default"] = _default;